module.exports = __webpack_public_path__ + "static/media/we.ae804c1d.svg";